import { BASE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  GET: 'STUDENT_GET',
  GET_SUCCESS: 'STUDENT_GET_SUCCESS',
  GET_FAILURE: 'STUDENT_GET_FAILURE',

  PATCH: 'STUDENT_PATCH',
  PATCH_SUCCESS: 'STUDENT_PATCH_SUCCESS',
  PATCH_FAILURE: 'STUDENT_PATCH_FAILURE',

  INVALIDATE_ITEM: 'STUDENT_INVALIDATE_ITEM',
};

export const get = actions.get(studentId => `${BASE_URL}/students/${studentId}/`, {
  PENDING: ACTIONS.GET,
  SUCCESS: ACTIONS.GET_SUCCESS,
  FAILURE: ACTIONS.GET_FAILURE,
});

export const patch = actions.patch(studentId => `${BASE_URL}/students/${studentId}/`, {
  PENDING: ACTIONS.PATCH,
  SUCCESS: ACTIONS.PATCH_SUCCESS,
  FAILURE: ACTIONS.PATCH_FAILURE,
});

export const invalidateItem = id => dispatch => {
  dispatch({
    type: ACTIONS.INVALIDATE_ITEM,
    payload: { id },
  });
};
